import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Grid, Loader } from 'semantic-ui-react';
import { searchFoldersOpened, assignOpenedBy } from 'services/folder';
import CustomPagination from 'components/CustomPagination';
import FolderListItem from 'features/SecretaryHome/components/FolderListItem';
import SearchInput from 'features/Lab/components/SearchInput';

const styles = {
	folder: {
		backgroundColor: '#fff',
		width: '100%',
		padding: 10,
		display: 'flex',
		borderRadius: '0',
		marginTop: '5px',
		boxShadow: '0px 9px 35px -23px rgba(148,148,148,1)',
		alignItems: 'center',
		marginLeft: 15,
		marginRight: 15,
		position: 'relative',
	},
	roundHeaderContainer: {
		height: 40,
		backgroundColor: '#43b39e',
		width: '100%',
		padding: 10,
		display: 'flex',
		borderRadius: '4px 4px 0 0',
		boxShadow: '0px 9px 35px -23px rgba(148,148,148,1)',
		position: 'relative',
	},
};

class OpenedFolders extends Component {
	constructor(props) {
		super(props);

		this.folderTimeout = 0;

		this.state = {
			total: null,
			week: null,
			yersteday: null,
			today: null,
			currentPage: 0,
			pages: 0,
			folderTotalCount: 0,
			folders: null,
			isLoading: false,
			currentFolderFilterSearch: '',
		};
	}

	componentDidMount() {
		this.loadAll();
	}

	loadList = (page = 1) => {
		this.setState({ isLoading: true });
		this.props
			.searchFoldersOpened(
				this.state.currentFolderFilterSearch,
				this.props.user?.session?.center,
				this.props.user?.session?.id,
				page
			)
			.then((res) => {
				if (res.payload){
					const { data } = res.payload;
					this.setState({
						currentPage: data.page,
						pages: data.numberOfPages,
						folderTotalCount: data.totalCount,
						folders: data.results,
						isLoading: false,
					});
				}
			});
	};

	loadAll = () => {
		this.loadList(this.state.currentPage !== 0 ? this.state.currentPage : 1);
	};

	changeFolderSearchInput = (value) => {
		if (this.folderTimeout) clearTimeout(this.folderTimeout);

		if (value !== this.state.currentFolderFilterSearch) {
			this.setState({ currentFolderFilterSearch: value });
		}
		// Trigger the search after the user stopped typing
		this.folderTimeout = setTimeout(() => {
			if (
				this.state.currentFolderFilterSearch.length >= 3 ||
				this.state.currentFolderFilterSearch.length === 0
			) {
				this.loadList(1);
			}
		}, 500);
	};

	render() {
		const {
			currentPage,
			pages,
			folderTotalCount,
			folders,
			isLoading,
			currentFolderFilterSearch,
		} = this.state;

		return (
			<div
				style={{
					height: '100vh',
					overflowY: 'scroll',
				}}
			>
				<Grid
					className='ui container'
					style={{
						maxHeight: '100vh',
						maxWidth: '90%',
						display: 'flex',
						justifyContent: 'center',
						paddingTop: 73,
					}}
				>
					<Grid.Row style={{ paddingTop: 0 }}>
						<SearchInput
							onChange={(e) => this.changeFolderSearchInput(e.target.value)}
							current={currentFolderFilterSearch}
							resetInput={async () => {
								await this.setState({ currentFolderFilterSearch: '' });
								this.loadList(1);
							}}
							placeholder={'Rechercher un dossier'}
						/>
					</Grid.Row>
					<Grid.Row style={styles.roundHeaderContainer}>
						<Grid.Column
							computer={12}
							tablet={12}
							mobile={12}
							style={{ color: 'white' }}
						>
							Dossiers ouverts{' '}
							{this.props.centers?.center
								? `à ${this.props.centers.center.name}`
								: ''}
						</Grid.Column>
						<Grid.Column
							computer={4}
							tablet={4}
							mobile={4}
							style={{
								color: 'white',
								display: 'flex',
								justifyContent: 'flex-end',
							}}
						>
							Total: {folderTotalCount}
						</Grid.Column>
					</Grid.Row>
					<Grid.Row>
						{isLoading && <Loader active />}
						{!isLoading && folderTotalCount > 0 ? (
							<Grid
								style={{
									display: 'flex',
									flex: 1,
								}}
							>
								{folders.map((f) => (
									<FolderListItem
										key={'openedFolder'+f.id}
										folder={f}
										generalParameters={this.props.generalParameters}
										user={this.props.user}
										onPressText={'Prendre la main'}
										handleOnPress={async () => {
											await this.props.assignOpenedBy(f.id, true);
											this.loadAll();
										}}
									/>
								))}
							</Grid>
						) : (
							'Aucun dossier'
						)}
					</Grid.Row>
					<Grid.Row>
						<CustomPagination
							activePage={currentPage}
							totalPages={pages}
							onPageChange={(e, { activePage }) => {
								this.loadList(activePage);
							}}
						/>
					</Grid.Row>
				</Grid>
			</div>
		);
	}
}

const mapStateToProps = (state) => {
	return {
		generalParameters: state.generalParameters,
		user: state.user,
		centers: state.centers,
	};
};

const mapDispatchToProps = {
	searchFoldersOpened,
	assignOpenedBy,
};

export default connect(mapStateToProps, mapDispatchToProps)(OpenedFolders);
